import axios from "axios";

export const qriApi = axios.create({
  headers: {
    "Content-Type": "application/json",
  },
  baseURL: `${import.meta.env.VITE_QRI_SERVICE_HOSTNAME}`,
  withCredentials: true,
});
